import { ZodNullable, ZodObject, ZodRawShape, z } from 'zod';

import { type AnyZodSchema } from '@Common/types/zod/utils';

type NullableObjectProperties<Shape extends ZodRawShape> = ZodObject<{
  [K in keyof Shape]: ZodNullable<Shape[K]>;
}>;

export function nullableZodObjectProperties<Shape extends ZodRawShape>(
  validator: ZodObject<Shape>,
): NullableObjectProperties<Shape> {
  const nullableShape: Record<string, AnyZodSchema> = {};

  for (const key in validator.shape) {
    nullableShape[key] = z.nullable(validator.shape[key]);
  }

  return z.object(nullableShape) as unknown as NullableObjectProperties<Shape>;
}
